import { css, keyframes } from 'emotion';
import { Size } from '@components/Spinner';

const sizeRules: { [size in Size]: number } = {
  small: 20,
  medium: 35,
  large: 50
};

export namespace styles {
  export const loaderWrapper = (fullscreen: boolean, transparentBackground: boolean, style: {}) =>
    css({
      position: fullscreen ? 'fixed' : 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      overflow: 'hidden',
      backgroundColor: !transparentBackground ? '#fff' : undefined,
      zIndex: 100,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      ...style
    });

  export const spinAnimation = keyframes({
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' }
  });

  export const loader = (size: Size) => {
    const length = sizeRules[size];
    return css({
      height: length,
      width: length,
      border: `2px solid rgba(0, 0, 0, 0.1)`,
      borderTopColor: 'black',
      borderRadius: '50%',
      animation: `${spinAnimation} 1.5s ease infinite`
    });
  };
}
